<div class="row g-0">
  <h1 class="offer" translate></h1>
</div>

<app-common-modal #addReferenceModal [name]="'addReference'" [title]=" " [twoButtonsDialogs]="true"
                  [withFooter]="false">
  <h4 class="modal-title" modal-title translate>T_OFFER_DATA_MANAGEMENT_ADD_NEW_REFERENCE</h4>
  <div modal-body>


    <div class="row g-0">
      <app-spinner *ngIf="loading" [sizeClass]="'medium'"></app-spinner>
      <div *ngIf="!loading" class="content-container">
        <div *ngIf="!isReferenceInputEnabled()" class="input-group custom-search-group">
          <p-autoComplete (completeMethod)="filterReferences()"
                          [(ngModel)]="reference"
                          [emptyMessage]="'T_OFFER_DATA_MANAGEMENT_NO_REFERENCE_FOUND' | translate"
                          [placeholder]="'T_OFFER_DATA_MANAGEMENT_SEARCH_REFERENCE' | translate"
                          [size]="64"
                          [suggestions]="filteredList" class="flex-grow-1"
                          scrollHeight="120px"></p-autoComplete>
          <button class="search-btn" disabled type="button">
            <span class="se-icons">action_search</span>
          </button>
        </div>
        <div *ngIf="isReferenceInputEnabled()">
          <div class="form-group">
            <label *ngIf="isBudgetaryQuoteRange() || isTransformSelectedRange()" class="normal-label" for="referenceInput">{{ 'T_OFFER_DATA_MANAGEMENT_ENTER_REFERENCE' | translate }}
              :</label>
            <input (ngModelChange)="validateInput($event); isValidForm()"
                   [(ngModel)]="newReference"
                   [disabled]="isModifyReferenceMode"
                   class="form-control  normal-input"
                   id="referenceInput"
                   style="font-weight: normal;"
                   type="text"
            />
            <div *ngIf="showError && newReference && !isReferenceValid()" class="text-danger">
              <em translate>T_OFFER_DATA_MANAGEMENT_ONLY_ALPHANUMERIC_ALLOWED</em>
            </div>
          </div>
        </div>
        <div *ngIf="showSldAndLayoutSelector()" class="input-group input-add-sld">
          <input [value]="displaySldList()" class="form-control search-input" disabled
                 id="sld"
                 type="text">
          <button (click)="getSLDList()" class="btn add-sld-btn field-mandatory" type="button">
            <em translate>T_OFFER_DATA_MANAGEMENT_ADD_SLD</em>
          </button>
        </div>

        <div *ngIf="showSldAndLayoutSelector()" class="input-group input-add-layout">
          <input [value]="displayLayoutList()" class="form-control search-input" disabled
                 id="layout"
                 type="text">
          <button (click)="getLayoutList()" class="btn add-layout-btn" type="button">
            <em translate>T_OFFER_DATA_MANAGEMENT_ADD_LAYOUT</em>
          </button>
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="modal-add-reference-footer form-horizontal">
      <button (click)="hide()" class="btn btn-default-white-background" translate>T_BUTTON_CANCEL</button>
      <button (click)="addReference(); hide()" [disabled]="!isValidForm()" class="btn btn-default-white-background">
        {{ (isModifyReferenceMode ? 'T_ADD_SELECTION' : 'T_OFFER_DATA_MANAGEMENT_ADD_REFERENCE') | translate }}
      </button>
    </div>

    <div *ngIf="showSldAndLayoutSelector()" class="mandatory-message">
      <em class="field-mandatory"></em>
      <span translate>T_OFFER_DATA_MANAGEMENT_MANDATORY_FIELDS</span>
    </div>

  </div>
</app-common-modal>


<!--Modal add sld-->
<app-common-modal #sldModal [closable]="false" [name]="'sldModal'" [title]="'T_OFFER_DATA_MANAGEMENT_ADD_SLD' | translate"
                  [withFooter]="false" size="modal-lg">
  <div class="form-horizontal" modal-body>
    <app-odm-offer-sld
      (onClickAddButton)="getSldToAddOnReference($event)"
      (onClickCancelButton)="sldModal.hide()"
      [loading]="loadingSld"
      [sldList]="sldList">
    </app-odm-offer-sld>
  </div>
</app-common-modal>


<!--Modal add layout-->
<app-common-modal #layoutModal [closable]="false" [name]="'layoutModal'" [title]="'T_OFFER_DATA_MANAGEMENT_ADD_LAYOUT' | translate"
                  [withFooter]="false" size="modal-lg">
  <div class="form-horizontal" modal-body>
    <app-offer-data-management-offer-layout
      (onClickAddButton)="getLayoutToAddOnReference($event)"
      (onClickCancelButton)="layoutModal.hide()"
      [layoutList]="layoutList"
      [loading]="loadingLayout">
    </app-offer-data-management-offer-layout>
  </div>
</app-common-modal>
